module.exports = __webpack_public_path__ + "73e85f788f91071b0aa074dac093b223.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/gorilla.svg
// module id = 89
// module chunks = 0